import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './over-write.scss'
import App from './App';
// import * as Sentry from "@sentry/react";


// Sentry.init({
//   dsn: "https://de85f242dcf737a50983665b91897b94@o419005.ingest.us.sentry.io/4507785271115776",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   tracesSampleRate: 1.0,

//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   replaysSessionSampleRate: 0.1, 
//   replaysOnErrorSampleRate: 1.0, 
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Fragment>
      <App /> 
      </React.Fragment>

);
